module.exports = __webpack_public_path__ + "cf00744e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/ProfilePhoto/defaultPic.png
// module id = 2771
// module chunks = 15